<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	let { children, class: classList = '' } = $props();
</script>

<p class={twMerge('lg:h2 h3 text-foreground', classList)}>{@render children()}</p>
